import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { ifProp, theme } from 'styled-tools';
import { css } from 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import { bool } from 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      margin: 1em 0;\n      height: 0;\n      border-width: 1px 0 0 0;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      margin: 0 1em;\n      min-height: 100%;\n      width: 0;\n      border-width: 0 0 0 1px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: currentColor;\n  border-style: solid;\n  opacity: 0.2;\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Divider = styled(Box)(_templateObject(), ifProp("vertical", css(_templateObject2()), css(_templateObject3())), theme("Divider")); // @ts-ignore

Divider.propTypes = {
  vertical: bool
};
var Divider$1 = use(Divider, "hr");

export default Divider$1;
